module.exports = __webpack_public_path__ + "static/img/login.e682328d.png";